import { ORDER_STATUS } from "../../constants/checkout-constants";

export const getTestDriveCtaText = (status) => {
    switch (status) {
    case ORDER_STATUS.BOOKED: {
        return "TRACK BOOKING";
    }
    default: {
        return "BOOK TEST DRIVE";
    }
    }

};
